module.exports = __webpack_public_path__ + "img/element-logo.0e11c581.svg";